module.exports = __webpack_public_path__ + "img/t_0036.c75e4943.gif";